import { DC } from "../../constants";

export const normalAchievements = [
  {
    id: 11,
    name: "You gotta start somewhere",
    description: "Buy a 1st Antimatter Dimension.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 12,
    name: "100 antimatter is a lot",
    description: "Buy a 2nd Antimatter Dimension.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 13,
    name: "Half life 3 CONFIRMED",
    description: "Buy a 3rd Antimatter Dimension.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 14,
    name: "L4D: Left 4 Dimensions",
    description: "Buy a 4th Antimatter Dimension.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 15,
    name: "5 Dimension Antimatter Punch",
    description: "Buy a 5th Antimatter Dimension.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 16,
    name: "We couldn't afford 9",
    get description() {
      return Enslaved.isRunning
        ? "Buy a 6th Antimatter Dimension (they never amount to anything)"
        : "Buy a 6th Antimatter Dimension.";
    },
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 17,
    name: "Not a luck related achievement",
    description: "Buy a 7th Antimatter Dimension.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 18,
    name: "90 degrees to infinity",
    get description() {
      return Enslaved.isRunning
        ? "Buy an 8th Antimatter Dimension (don't get used to it)"
        : "Buy an 8th Antimatter Dimension.";
    },
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 21,
    name: "To infinity!",
    description: "Go Infinite.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Start with ${formatInt(100)} antimatter.`;
    },
    effect: 100,
  },
  {
    id: 22,
    name: "FAKE NEWS!",
    get description() {
      return `Encounter ${formatInt(50)} different news messages.`;
    },
    checkRequirement: () => NewsHandler.uniqueTickersSeen >= 50,
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
  },
  {
    id: 23,
    name: "The 9th Dimension is a lie",
    get description() {
      return `Have exactly ${formatInt(99)} 8th Antimatter Dimensions.`;
    },
    checkRequirement: () => AntimatterDimension(8).totalAmount.eq(99),
    get reward() {
      return `8th Antimatter Dimensions are ${formatPercents(0.1)} stronger.`;
    },
    effect: 1.1,
  },
  {
    id: 24,
    name: "Antimatter Apocalypse",
    get description() {
      return `Get over ${format(DC.E80)} antimatter.`;
    },
    checkRequirement: () => Currency.antimatter.exponent >= 80,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 25,
    name: "Boosting to the max",
    get description() {
      return `Buy ${formatInt(10)} Dimension Boosts.`;
    },
    checkRequirement: () => DimBoost.purchasedBoosts >= 10,
    checkEvent: GAME_EVENT.DIMBOOST_AFTER,
  },
  {
    id: 26,
    name: "You got past The Big Wall",
    description: "Buy an Antimatter Galaxy.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.GALAXY_RESET_BEFORE,
  },
  {
    id: 27,
    name: "Double Galaxy",
    get description() {
      return `Buy ${formatInt(2)} Antimatter Galaxies.`;
    },
    checkRequirement: () => player.galaxies >= 2,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
  },
  {
    id: 28,
    name: "There's no point in doing that...",
    get description() {
      return `Buy a single 1st Antimatter Dimension when you have over ${format(DC.E150)} of them.`;
    },
    checkRequirement: () => AntimatterDimension(1).totalAmount.exponent >= 150,
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
    get reward() {
      return `1st Antimatter Dimensions are ${formatPercents(0.1)} stronger.`;
    },
    effect: 1.1,
  },
  {
    id: 31,
    name: "I forgot to nerf that",
    get description() {
      return `Get any Antimatter Dimension multiplier over ${formatX(DC.E31)}.`;
    },
    checkRequirement: () => AntimatterDimensions.all.some((x) => x.multiplier.exponent >= 31),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `1st Antimatter Dimensions are ${formatPercents(0.05)} stronger.`;
    },
    effect: 1.05,
  },
  {
    id: 32,
    name: "The Gods are pleased",
    get description() {
      return `Get over ${formatX(600)} from Dimensional Sacrifice outside of Challenge 8.`;
    },
    checkRequirement: () => !NormalChallenge(8).isOnlyActiveChallenge && Sacrifice.totalBoost.gte(600),
    checkEvent: GAME_EVENT.SACRIFICE_RESET_AFTER,
    get reward() {
      return `Dimensional Sacrifice is stronger.
      ${Sacrifice.getSacrificeDescription({ Achievement32: false, Achievement57: false, Achievement88: false })} ➜
      ${Sacrifice.getSacrificeDescription({ Achievement32: true, Achievement57: false, Achievement88: false })}`;
    },
    effect: 0.1,
  },
  {
    id: 33,
    name: "That's a lot of infinites",
    get description() {
      return `Reach Infinity ${formatInt(10)} times.`;
    },
    checkRequirement: () => Currency.infinities.gte(10),
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
  },
  {
    id: 34,
    name: "You didn't need it anyway",
    description: "Infinity without having any 8th Antimatter Dimensions.",
    checkRequirement: () => AntimatterDimension(8).totalAmount.eq(0),
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Dimensions 1-7 are ${formatPercents(0.02)} stronger.`;
    },
    effect: 1.02,
  },
  {
    id: 35,
    name: "Don't you dare sleep",
    get description() {
      return PlayerProgress.realityUnlocked()
        ? `Be offline for a period of over ${formatInt(6)} hours (real time).`
        : `Be offline for a period of over ${formatInt(6)} hours.`;
    },
    checkRequirement: () => Date.now() - player.lastUpdate >= 21600000,
    checkEvent: GAME_EVENT.GAME_TICK_BEFORE,
  },
  {
    id: 36,
    name: "Claustrophobic",
    get description() {
      return `Infinity with just ${formatInt(1)} Antimatter Galaxy. (Your Antimatter Galaxies are reset on Infinity.)`;
    },
    checkRequirement: () => player.galaxies === 1,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Multiply starting tick speed by ${format(1.02, 2, 2)}.`;
    },
    effect: 1 / 1.02,
  },
  {
    id: 37,
    name: "That's FAST!",
    get description() {
      return `Infinity in under ${formatInt(2)} hours.`;
    },
    checkRequirement: () => Time.thisInfinityRealTime.totalHours <= 2,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Start with ${formatInt(5000)} antimatter.`;
    },
    effect: 5000,
  },
  {
    id: 38,
    name: "I don't believe in Gods",
    get description() {
      return `Buy an Antimatter Galaxy without Dimensional Sacrificing.
        (Your Antimatter Galaxies are reset on Infinity.)`;
    },
    checkRequirement: () => player.requirementChecks.infinity.noSacrifice,
    checkEvent: GAME_EVENT.GALAXY_RESET_BEFORE,
  },
  {
    id: 41,
    name: "No DLC required",
    get description() {
      return `Buy ${formatInt(16)} Infinity Upgrades.`;
    },
    checkRequirement: () => player.infinityUpgrades.size >= 16,
    checkEvent: [
      GAME_EVENT.INFINITY_UPGRADE_BOUGHT,
      GAME_EVENT.REALITY_RESET_AFTER,
      GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT,
    ],
    get reward() {
      return `Unlock two new Infinity Upgrades- ${formatX(2)} IP multiplier and offline IP generation.`;
    },
  },
  {
    id: 42,
    name: "Super Sanic",
    get description() {
      return `Have antimatter per second exceed your current antimatter above ${format(DC.E63)}.`;
    },
    checkRequirement: () =>
      Currency.antimatter.exponent >= 63 && Currency.antimatter.productionPerSecond.gt(Currency.antimatter.value),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 43,
    name: "How the antitables have turned..",
    description:
      "Get the 8th Antimatter Dimension multiplier to be highest, 7th Antimatter Dimension multiplier " +
      " second highest, etc.",
    checkRequirement: () => {
      const multipliers = Array.range(1, 8).map((tier) => AntimatterDimension(tier).multiplier);
      for (let i = 0; i < multipliers.length - 1; i++) {
        if (multipliers[i].gte(multipliers[i + 1])) return false;
      }
      return true;
    },
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Each Antimatter Dimension gains a boost proportional to tier
      (8th gets ${formatPercents(0.08)}, 7th gets ${formatPercents(0.07)}, etc.)`;
    },
  },
  {
    id: 44,
    name: "Over in 30 Seconds",
    get description() {
      return `Have antimatter per second exceed your current antimatter
      for ${formatInt(30)} consecutive seconds.`;
    },
    checkRequirement: () =>
      AchievementTimers.marathon1.check(Currency.antimatter.productionPerSecond.gt(Currency.antimatter.value), 30),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 45,
    name: "Faster than a potato",
    get description() {
      return `Get more than ${format(DC.E29)} ticks per second.`;
    },
    checkRequirement: () => Tickspeed.current.exponent <= -26,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Multiply starting tickspeed by ${formatX(1.02, 0, 2)}.`;
    },
    effect: 0.98,
  },
  {
    id: 46,
    name: "Multidimensional",
    get description() {
      return `Reach ${format(DC.E12)} of all Antimatter Dimensions except the 8th.`;
    },
    checkRequirement: () => AntimatterDimension(7).totalAmount.exponent >= 12,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 47,
    name: "Daredevil",
    get description() {
      return `Complete ${formatInt(3)} Normal Challenges.`;
    },
    checkRequirement: () => NormalChallenges.all.countWhere((c) => c.isCompleted) >= 3,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
  },
  {
    id: 48,
    name: "Antichallenged",
    get description() {
      return `Complete all ${formatInt(12)} Normal Challenges.`;
    },
    checkRequirement: () => NormalChallenges.all.countWhere((c) => !c.isCompleted) === 0,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
    get reward() {
      return `All Dimensions are ${formatPercents(0.1)} stronger.`;
    },
    effect: 1.1,
  },
  {
    id: 51,
    name: "Limit Break",
    description: "Break Infinity.",
    checkRequirement: () => player.break,
    checkEvent: [GAME_EVENT.BREAK_INFINITY, GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
  },
  {
    id: 52,
    name: "Age of Automation",
    description: "Max the interval for Antimatter Dimension and Tickspeed upgrade autobuyers.",
    checkRequirement: () =>
      Autobuyer.antimatterDimension.zeroIndexed
        .concat(Autobuyer.tickspeed)
        .every((a) => a.isUnlocked && a.hasMaxedInterval),
    checkEvent: [GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
  },
  {
    id: 53,
    name: "Definitely not worth it",
    description: "Max the intervals for all normal autobuyers.",
    // The upgradeable autobuyers are dimensions, tickspeed, dimension boost,
    // galaxy, and big crunch (the ones you get from normal challenges).
    // We don't count autobuyers which can be upgraded via e.g. perks as upgradeable.
    checkRequirement: () => Autobuyers.upgradeable.every((a) => a.isUnlocked && a.hasMaxedInterval),
    checkEvent: [GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
  },
  {
    id: 54,
    name: "That's FASTER!",
    get description() {
      return `Infinity in ${formatInt(10)} minutes or less.`;
    },
    checkRequirement: () => Time.thisInfinityRealTime.totalMinutes <= 10,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Start with ${format(5e5)} antimatter.`;
    },
    effect: 5e5,
  },
  {
    id: 55,
    name: "Forever isn't that long",
    get description() {
      return `Infinity in ${formatInt(1)} minute or less.`;
    },
    checkRequirement: () => Time.thisInfinityRealTime.totalMinutes <= 1,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Start with ${format(5e10)} antimatter.`;
    },
    effect: 5e10,
  },
  {
    id: 56,
    name: "Many Deaths",
    get description() {
      return `Complete the 2nd Antimatter Dimension Autobuyer Challenge in ${formatInt(3)} minutes or less.`;
    },
    checkRequirement: () => NormalChallenge(2).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalMinutes <= 3,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `All Antimatter Dimensions are stronger in the first ${formatInt(3)} minutes of Infinities.`;
    },
    effect: () => Decimal.div(6, Time.thisInfinity.totalMinutes.add(3)).max(1),
    effectCondition: () => Time.thisInfinity.totalMinutes.lt(3),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 57,
    name: "Gift from the Gods",
    get description() {
      return `Complete the 8th Antimatter Dimension Autobuyer Challenge in ${formatInt(3)} minutes or less.`;
    },
    checkRequirement: () => NormalChallenge(8).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalMinutes <= 3,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Dimensional Sacrifice is stronger.
      ${Sacrifice.getSacrificeDescription({ Achievement32: true, Achievement57: false, Achievement88: false })} ➜
      ${Sacrifice.getSacrificeDescription({ Achievement32: true, Achievement57: true, Achievement88: false })}`;
    },
    effect: 0.1,
  },
  {
    id: 58,
    name: "This is fine.",
    get description() {
      return `Complete the Tickspeed Autobuyer Challenge in ${formatInt(3)} minutes or less.`;
    },
    checkRequirement: () => NormalChallenge(9).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalMinutes <= 3,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Increase the multiplier for buying ${formatInt(10)} Antimatter Dimensions by +${formatPercents(0.01)}.`;
    },
    effect: 1.01,
  },
  {
    id: 61,
    name: "Bulked Up",
    get description() {
      return `Get all of your Antimatter Dimension Autobuyer bulk amounts to
        ${formatInt(Autobuyer.antimatterDimension.bulkCap)}.`;
    },
    checkRequirement: () => Autobuyer.antimatterDimension.zeroIndexed.every((x) => x.hasMaxedBulk),
    checkEvent: [
      GAME_EVENT.REALITY_RESET_AFTER,
      GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT,
      GAME_EVENT.SAVE_CONVERTED_FROM_PREVIOUS_VERSION,
    ],
    reward: "Dimension Autobuyer bulks are unlimited.",
  },
  {
    id: 62,
    name: "Oh, hey... You're still here?",
    get description() {
      return `Reach ${format(DC.E8)} Infinity Points per minute.`;
    },
    checkRequirement: () => Player.bestRunIPPM.exponent >= 8,
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
  },
  {
    id: 63,
    name: "A new beginning",
    description: "Begin generation of Infinity Power.",
    checkRequirement: () => Currency.infinityPower.gt(1),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 64,
    name: "Zero Deaths",
    description: "Get to Infinity without Dimension Boosts or Antimatter Galaxies while in a Normal Challenge.",
    checkRequirement: () => player.galaxies === 0 && DimBoost.purchasedBoosts === 0 && NormalChallenge.isRunning,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Antimatter Dimensions 1-4 are ${formatPercents(0.25)} stronger.`;
    },
    effect: 1.25,
  },
  {
    id: 65,
    name: "Not-so-challenging",
    get description() {
      return `Get the sum of all of your Normal Challenge times under ${formatInt(3)} minutes.`;
    },
    checkRequirement: () => Time.challengeSum.totalMinutes.lt(3),
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER],
    get reward() {
      return `All Antimatter Dimensions are stronger in the first ${formatInt(3)} minutes of Infinities,
      but only in Challenges.`;
    },
    effect: () => (Player.isInAnyChallenge ? Decimal.div(4, Time.thisInfinity.totalMinutes.add(1)).max(1) : DC.D1),
    effectCondition: () => Player.isInAnyChallenge && Time.thisInfinity.totalMinutes.lt(3),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 66,
    name: "Faster than a squared potato",
    get description() {
      return `Get more than ${format(DC.E58)} ticks per second.`;
    },
    checkRequirement: () => Tickspeed.current.exponent <= -55,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Multiply starting tickspeed by ${formatX(1.02, 0, 2)}.`;
    },
    effect: 0.98,
  },
  {
    id: 67,
    name: "Infinitely Challenging",
    description: "Complete an Infinity Challenge.",
    checkRequirement: () => InfinityChallenges.completed.length > 0,
    checkEvent: [GAME_EVENT.INFINITY_CHALLENGE_COMPLETED, GAME_EVENT.REALITY_RESET_AFTER],
  },
  {
    id: 68,
    name: "You did this again just for the achievement right?",
    get description() {
      return `Complete the 3rd Antimatter Dimension Autobuyer Challenge in ${formatInt(10)} seconds or less.`;
    },
    checkRequirement: () => NormalChallenge(3).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalSeconds <= 10,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `1st Antimatter Dimensions are ${formatPercents(0.5)} stronger.`;
    },
    effect: 1.5,
  },
  {
    id: 71,
    name: "ERROR 909: Dimension not found",
    description: `Get to Infinity with only a single 1st Antimatter Dimension without Dimension Boosts
      or Antimatter Galaxies, while in the 2nd Antimatter Dimension Autobuyer Challenge.`,
    checkRequirement: () =>
      NormalChallenge(2).isOnlyActiveChallenge &&
      AntimatterDimension(1).totalAmount.eq(1) &&
      DimBoost.purchasedBoosts === 0 &&
      player.galaxies === 0,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `1st Antimatter Dimensions are ${formatInt(3)} times stronger.`;
    },
    effect: 3,
  },
  {
    id: 72,
    name: "Can't hold all these infinities",
    get description() {
      return `Get all Antimatter Dimension multipliers over ${formatX(Decimal.NUMBER_MAX_VALUE, 1)}.`;
    },
    checkRequirement: () => AntimatterDimensions.all.every((x) => x.multiplier.gte(Decimal.NUMBER_MAX_VALUE)),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `All Antimatter Dimensions are ${formatPercents(0.1)} stronger.`;
    },
    effect: 1.1,
  },
  {
    id: 73,
    name: "THIS ACHIEVEMENT DOESN'T EXIST",
    get description() {
      return `Get ${formatPostBreak(DC.D9_9999E9999, 4)} antimatter.`;
    },
    checkRequirement: () => Currency.antimatter.gte(DC.D9_9999E9999),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Antimatter Dimensions gain a multiplier based on current antimatter.",
    effect: () => Currency.antimatter.value.pow(0.00002).plus(1),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 74,
    name: "Not a second lost",
    get description() {
      return `Get the sum of all best Normal Challenge times under ${formatInt(5)} seconds.`;
    },
    checkRequirement: () => Time.challengeSum.totalSeconds.lt(5),
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER],
    get reward() {
      return `All Antimatter Dimensions are ${formatPercents(0.4)} stronger, but only in challenges.`;
    },
    effect: 1.4,
    effectCondition: () => Player.isInAnyChallenge,
  },
  {
    id: 75,
    name: "NEW DIMENSIONS???",
    description: "Unlock the 4th Infinity Dimension.",
    checkRequirement: () => InfinityDimension(4).isUnlocked,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Your Achievement bonus affects Infinity Dimensions.",
    effect: () => Achievements.power,
  },
  {
    id: 76,
    name: "One for each dimension",
    get description() {
      return `Play for ${formatInt(8)} days${atomTimeText()}.`;
    },
    checkRequirement: () => Time.thisCollapse.totalDays.gte(8),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Extremely small multiplier to Antimatter Dimensions based on time played.",
    effect: () => Time.thisCollapse.totalDays.div(2).pow(0.05).max(1),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 77,
    name: "1 Million is a lot",
    get description() {
      return `Reach ${format(1e6)} Infinity Power.`;
    },
    checkRequirement: () => Currency.infinityPower.exponent >= 6,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 78,
    name: "Blink of an eye",
    get description() {
      return `Infinity in under ${formatInt(250)}ms.`;
    },
    checkRequirement: () => Time.thisInfinityRealTime.totalMilliseconds <= 250,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Start with ${format(5e25)} antimatter.`;
    },
    effect: 5e25,
  },
  {
    id: 81,
    name: "Game Design Is My Passion",
    get description() {
      return `Beat Infinity Challenge 5 in ${formatInt(15)} seconds or less.`;
    },
    checkRequirement: () => InfinityChallenge(5).isRunning && Time.thisInfinityRealTime.totalSeconds <= 15,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
  },
  {
    id: 82,
    name: "Anti-antichallenged",
    get description() {
      return `Complete all ${formatInt(8)} Infinity Challenges.`;
    },
    checkRequirement: () => InfinityChallenges.completed.length === 8,
    checkEvent: [GAME_EVENT.INFINITY_CHALLENGE_COMPLETED, GAME_EVENT.REALITY_RESET_AFTER],
  },
  {
    id: 83,
    name: "YOU CAN GET 50 GALAXIES?!?!",
    get description() {
      return `Get ${formatInt(50)} Antimatter Galaxies.`;
    },
    checkRequirement: () => player.galaxies >= 50,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    get reward() {
      return `Tickspeed is just over ${formatPercents(0.05)} faster per Antimatter Galaxy.`;
    },
    effect: () => DC.D0_95.pow(player.galaxies),
    formatEffect: (value) => `${formatX(value.recip(), 2, 2)}`,
  },
  {
    id: 84,
    name: "I got a few to spare",
    get description() {
      return `Reach ${formatPostBreak("1e35000")} antimatter.`;
    },
    checkRequirement: () => Currency.antimatter.exponent >= 35000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Antimatter Dimensions are stronger the more unspent antimatter you have.",
    effect: () => Currency.antimatter.value.pow(0.00002).plus(1),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 85,
    name: "ALL YOUR IP ARE BELONG TO US",
    get description() {
      return `Big Crunch for ${format(DC.E150)} Infinity Points.`;
    },
    checkRequirement: () => gainedInfinityPoints().exponent >= 150,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Additional ${formatX(4)} multiplier to Infinity Points.`;
    },
    effect: 4,
  },
  {
    id: 86,
    name: "Do you even bend time bro?",
    get description() {
      return `Reach ${formatX(1000)} faster per Tickspeed upgrade.`;
    },
    checkRequirement: () => Tickspeed.multiplier.recip().gte(1000),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `All Galaxies are ${formatPercents(0.01)} stronger.`;
    },
    effect: 1.01,
  },
  {
    id: 87,
    name: "2 MILLION INFINITIES",
    get description() {
      return `Infinity ${format(DC.D2E6)} times.`;
    },
    checkRequirement: () => Currency.infinities.gt(DC.D2E6),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Infinities more than ${formatInt(5)} seconds long
      give ${formatX(250)} more Infinities.`;
    },
    effect: 250,
    effectCondition: () => Time.thisInfinity.totalSeconds.gt(5),
  },
  {
    id: 88,
    name: "Yet another infinity reference",
    get description() {
      return `Get a ${formatX(Decimal.NUMBER_MAX_VALUE, 1, 0)} multiplier in a single Dimensional Sacrifice.`;
    },
    checkRequirement: () => Sacrifice.nextBoost.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.SACRIFICE_RESET_BEFORE,
    get reward() {
      return `Dimensional Sacrifice is stronger.
      ${Sacrifice.getSacrificeDescription({ Achievement32: true, Achievement57: true, Achievement88: false })} ➜
      ${Sacrifice.getSacrificeDescription({ Achievement32: true, Achievement57: true, Achievement88: true })}`;
    },
    effect: 0.1,
  },
  {
    id: 91,
    name: "Ludicrous Speed",
    get description() {
      return `Big Crunch for ${format(DC.E200)} Infinity Points in ${formatInt(2)} seconds or less.`;
    },
    checkRequirement: () => gainedInfinityPoints().exponent >= 200 && Time.thisInfinityRealTime.totalSeconds <= 2,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `All Antimatter Dimensions are significantly stronger in the
      first ${formatInt(5)} seconds of Infinities.`;
    },
    effect: () => Decimal.sub(5, Time.thisInfinity.totalSeconds).mul(60).max(1),
    effectCondition: () => Time.thisInfinity.totalSeconds.lt(5),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 92,
    name: "I brake for NOBODY!",
    get description() {
      return `Big Crunch for ${format(DC.E250)} Infinity Points in ${formatInt(20)} seconds or less.`;
    },
    checkRequirement: () => gainedInfinityPoints().exponent >= 250 && Time.thisInfinityRealTime.totalSeconds <= 20,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `All Antimatter Dimensions are significantly stronger in the
      first ${formatInt(60)} seconds of Infinities.`;
    },
    effect: () => Decimal.sub(1, Time.thisInfinity.totalMinutes).mul(100).max(1),
    effectCondition: () => Time.thisInfinity.totalMinutes.lt(1),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 93,
    name: "MAXIMUM OVERDRIVE",
    get description() {
      return `Big Crunch for ${format(DC.E300)} Infinity Points.`;
    },
    checkRequirement: () => gainedInfinityPoints().exponent >= 300,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Additional ${formatX(4)} multiplier to Infinity Points.`;
    },
    effect: 4,
  },
  {
    id: 94,
    name: "4.3333 minutes of Infinity",
    get description() {
      return `Reach ${format(DC.E260)} Infinity Power.`;
    },
    checkRequirement: () => Currency.infinityPower.exponent >= 260,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Double Infinity Power gain.",
    effect: 2,
  },
  {
    id: 95,
    name: "Is this safe?",
    get description() {
      return `Gain ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} Replicanti in ${formatInt(1)} hour.`;
    },
    get reward() {
      return `You keep your Replicanti and ${formatInt(1)} Replicanti Galaxy on Infinity.`;
    },
    checkRequirement: () =>
      (Replicanti.amount.eq(Decimal.NUMBER_MAX_VALUE) || player.replicanti.galaxies > 0) &&
      Time.thisInfinityRealTime.totalHours <= 1,
    checkEvent: GAME_EVENT.REPLICANTI_TICK_AFTER,
  },
  {
    id: 96,
    name: "Time is relative",
    description: "Go Eternal.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
  },
  {
    id: 97,
    name: "Like jumping on a lego",
    get description() {
      return `Get the sum of Infinity Challenge times under ${format(6.66, 2, 2)} seconds.`;
    },
    checkRequirement: () => Time.infinityChallengeSum.totalSeconds.lt(6.66),
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER],
  },
  {
    id: 98,
    name: "0 degrees from Infinity",
    description: "Unlock the 8th Infinity Dimension.",
    checkRequirement: () => InfinityDimension(8).isUnlocked,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 101,
    name: "8 nobody got time for that",
    description: "Eternity without buying Antimatter Dimensions 1-7.",
    checkRequirement: () => player.requirementChecks.eternity.onlyAD8,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
  },
  {
    id: 102,
    name: "This mile took an eternity",
    description: "Get all Eternity milestones.",
    checkRequirement: () => EternityMilestone.all.every((m) => m.isReached),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 103,
    name: "Tätä saavutusta ei ole olemassa II",
    get description() {
      return `Reach ${formatPostBreak(DC.D9_99999E999, 5, 0)} Infinity Points.`;
    },
    checkRequirement: () => Currency.infinityPoints.exponent >= 1000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Make the Infinity Point formula better. log(x)/${formatInt(308)} ➜ log(x)/${formatFloat(307.8, 1)}`;
    },
    effect: 307.8,
  },
  {
    id: 104,
    name: "That wasn't an eternity",
    get description() {
      return `Eternity in under ${formatInt(30)} seconds.`;
    },
    checkRequirement: () => Time.thisEternity.totalSeconds.lte(30),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    get reward() {
      return `Start Eternities with ${format(5e25)} Infinity Points.`;
    },
    effect: 5e25,
  },
  {
    id: 105,
    name: "Infinite Time",
    get description() {
      return `Have ${formatInt(308)} Tickspeed upgrades from Time Dimensions.`;
    },
    checkRequirement: () => player.totalTickGained >= 308,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Time Dimensions gain a multiplier based on tickspeed.",
    effect: () => Tickspeed.perSecond.pow(0.000005),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 106,
    name: "The swarm",
    get description() {
      return `Get ${formatInt(10)} Replicanti Galaxies in ${formatInt(15)} seconds.`;
    },
    checkRequirement: () => Replicanti.galaxies.total >= 10 && Time.thisInfinity.totalSeconds.lte(15),
    checkEvent: GAME_EVENT.REPLICANTI_TICK_AFTER,
  },
  {
    id: 107,
    name: "Do you really need a guide for this?",
    get description() {
      return `Eternity with less than ${formatInt(10)} Infinities.`;
    },
    checkRequirement: () => Currency.infinities.lt(10),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
  },
  {
    id: 108,
    name: "We COULD afford 9",
    get description() {
      return `Eternity with exactly ${formatInt(9)} Replicanti.`;
    },
    checkRequirement: () => Replicanti.amount.round().eq(9),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
  },
  {
    id: 111,
    name: "Yo dawg, I heard you liked infinities...",
    get description() {
      return `Have all your Infinities in your past ${formatInt(10)} Infinities be at least
      ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} times higher Infinity Points than the previous one.`;
    },
    checkRequirement: () => {
      if (player.records.recentInfinities.some((i) => i[0].eq(Decimal.MAX_LIMIT))) return false;
      const infinities = player.records.recentInfinities.map((run) => run[2]);
      for (let i = 0; i < infinities.length - 1; i++) {
        if (infinities[i].lt(infinities[i + 1].times(Decimal.NUMBER_MAX_VALUE))) return false;
      }
      return true;
    },
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
    reward: "Your antimatter doesn't reset on Dimension Boosts or Antimatter Galaxies.",
  },
  {
    id: 112,
    name: "Never again",
    get description() {
      return `Get the sum of Infinity Challenge times below ${formatInt(750)}ms.`;
    },
    checkRequirement: () => Time.infinityChallengeSum.totalMilliseconds.lt(750),
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER],
  },
  {
    id: 113,
    name: "Eternities are the new infinity",
    get description() {
      return `Eternity in under ${formatInt(250)}ms.`;
    },
    checkRequirement: () => Time.thisEternity.totalMilliseconds.lte(250),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    get reward() {
      return `Gain ${formatX(2)} more Eternities.`;
    },
    effect: 2,
  },
  {
    id: 114,
    name: "You're a mistake",
    description: "Fail an Eternity Challenge.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.CHALLENGE_FAILED,
    reward: "A fading sense of accomplishment.",
    effect: () => "Sense of accomplishment (fading)",
  },
  {
    id: 115,
    name: "I wish I had gotten 7 eternities",
    description: "Start an Infinity Challenge inside an Eternity Challenge.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 116,
    name: "Do I really need to infinity",
    get description() {
      return `Eternity with only ${formatInt(1)} Infinity.`;
    },
    checkRequirement: () => Currency.infinities.lte(1),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    reward: "Multiplier to Infinity Points based on Infinities.",
    effect: () => Decimal.pow(Currency.infinitiesTotal.value.clampMin(1), LOG10_2 / 4).powEffectOf(TimeStudy(31)),
    cap: () => Effarig.eternityCap,
    formatEffect: (value) => {
      // Since TS31 is already accounted for in the effect prop, we need to "undo" it to display the base value here
      const mult = formatX(value, 2, 2);
      return TimeStudy(31).canBeApplied
        ? `${formatX(value.pow(1 / TimeStudy(31).effectValue), 2, 1)} (After TS31: ${mult})`
        : mult;
    },
  },
  {
    id: 117,
    name: "Costco sells Dimboosts now!",
    get description() {
      return `Bulk buy ${formatInt(750)} Dimension Boosts at once.`;
    },
    checkRequirement: ([bulk]) => bulk >= 750,
    checkEvent: GAME_EVENT.DIMBOOST_AFTER,
    get reward() {
      return `The multiplier from Dimension Boosts to Antimatter Dimensions is ${formatPercents(0.01)} higher.`;
    },
    effect: 1.01,
  },
  {
    id: 118,
    name: "IT'S OVER 9000",
    get description() {
      return `Get a total Dimensional Sacrifice multiplier of ${formatPostBreak(DC.E9000)}.`;
    },
    checkRequirement: () => Sacrifice.totalBoost.exponent >= 9000,
    checkEvent: GAME_EVENT.SACRIFICE_RESET_AFTER,
    reward: `Dimensional Sacrifice doesn't reset your Antimatter Dimensions
      and the Autobuyer activates every tick if turned on.`,
  },
  {
    id: 121,
    name: "Can you get infinite IP?",
    get description() {
      return `Reach ${formatPostBreak("1e30008")} Infinity Points.`;
    },
    checkRequirement: () => Currency.infinityPoints.exponent >= 30008,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 122,
    name: "You're already dead.",
    description: "Eternity without buying Antimatter Dimensions 2-8.",
    checkRequirement: () => player.requirementChecks.eternity.onlyAD1,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
  },
  {
    id: 123,
    name: "5 more eternities until the update",
    get description() {
      return `Complete ${formatInt(50)} unique Eternity Challenge tiers.`;
    },
    checkRequirement: () => EternityChallenges.completions >= 50,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
  },
  {
    id: 124,
    name: "Long lasting relationship",
    get description() {
      return `Have your Infinity Power per second exceed your Infinity Power
      for ${formatInt(60)} consecutive seconds during a single Infinity.`;
    },
    checkRequirement: () =>
      AchievementTimers.marathon2.check(
        !EternityChallenge(7).isRunning && InfinityDimension(1).productionPerSecond.gt(Currency.infinityPower.value),
        60,
      ),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 125,
    name: "Like feasting on a behind",
    get description() {
      return `Reach ${format(DC.E90)} Infinity Points without having any Infinities
      or any 1st Antimatter Dimensions in your current Eternity.`;
    },
    checkRequirement: () =>
      Currency.infinityPoints.exponent >= 90 && player.requirementChecks.eternity.noAD1 && Currency.infinities.eq(0),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Infinity Point multiplier based on time spent this Infinity.",
    effect() {
      const thisInfinity = Time.thisInfinity.totalSeconds.mul(10).add(1);
      return DC.D2.pow(thisInfinity.pow(0.11).min(500).mul(thisInfinity.ln()));
    },
    cap: () => Effarig.eternityCap,
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 126,
    name: "Popular music",
    get description() {
      return `Have ${formatInt(180)} times more Replicanti Galaxies than Antimatter Galaxies.`;
    },
    checkRequirement: () => Replicanti.galaxies.total >= 180 * player.galaxies && player.galaxies > 0,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Replicanti Galaxies divide your Replicanti by ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)}
      instead of resetting them to ${formatInt(1)}.`;
    },
  },
  {
    id: 127,
    name: "But I wanted another prestige layer...",
    get description() {
      return `Reach ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} Eternity Points.`;
    },
    checkRequirement: () => Currency.eternityPoints.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 128,
    name: "What do I have to do to get rid of you",
    get description() {
      return `Reach ${formatPostBreak("1e22000")} Infinity Points without any Time Studies.`;
    },
    checkRequirement: () => Currency.infinityPoints.exponent >= 22000 && player.timestudy.studies.length === 0,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Time Dimensions are multiplied by the number of Time Studies you have.",
    effect: () => Math.max(player.timestudy.studies.length, 1),
    formatEffect: (value) => `${formatX(value)}`,
  },
  {
    id: 131,
    name: "No ethical consumption",
    get description() {
      return `Get ${format(DC.D2E9)} Banked Infinities.`;
    },
    checkRequirement: () => Currency.infinitiesBanked.gt(DC.D2E9),
    checkEvent: [GAME_EVENT.ETERNITY_RESET_AFTER, GAME_EVENT.SAVE_CONVERTED_FROM_PREVIOUS_VERSION],
    get reward() {
      return `You gain ${formatX(2)} times more Infinities and
      after Eternity you permanently keep ${formatPercents(0.05)} of your Infinities as Banked Infinities.`;
    },
    effects: {
      infinitiesGain: 2,
      bankedInfinitiesGain: () => Currency.infinities.value.times(0.05).floor(),
    },
  },
  {
    id: 132,
    name: "Unique snowflakes",
    get description() {
      return `Have ${formatInt(569)} Antimatter Galaxies without gaining any
        Replicanti Galaxies in your current Eternity.`;
    },
    checkRequirement: () => player.galaxies >= 569 && player.requirementChecks.eternity.noRG,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    reward: "Gain a multiplier to Tachyon Particle and Dilated Time gain based on Antimatter Galaxies.",
    effect: () => 1.22 * Math.max(Math.pow(player.galaxies, 0.04), 1),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 133,
    name: "I never liked this infinity stuff anyway",
    get description() {
      return `Reach ${formatPostBreak(DC.E200000)} Infinity Points without
      buying any Infinity Dimensions or the ${formatX(2)} Infinity Point multiplier.`;
    },
    checkRequirement: () =>
      Array.dimensionTiers.map(InfinityDimension).every((dim) => dim.baseAmount === 0) &&
      player.IPMultPurchases === 0 &&
      Currency.infinityPoints.exponent >= 200000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "You start Eternities with all Infinity Challenges unlocked and completed.",
  },
  {
    id: 134,
    name: "When will it be enough?",
    get description() {
      return `Reach ${formatPostBreak(DC.E18000)} Replicanti.`;
    },
    checkRequirement: () => Replicanti.amount.exponent >= 18000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `You gain Replicanti ${formatInt(2)} times faster under ${format(replicantiCap(), 1)} Replicanti.`;
    },
  },
  {
    id: 135,
    name: "Faster than a potato^286078",
    get description() {
      return `Get more than ${formatPostBreak("1e8296262")} ticks per second.`;
    },
    checkRequirement: () => Tickspeed.current.exponent <= -8296262,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 136,
    name: "I told you already, time is relative",
    description: "Dilate time.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 137,
    name: "Now you're thinking with dilation!",
    get description() {
      return `Get ${formatPostBreak("1e260000")} antimatter
      in ${formatInt(1)} minute or less while Dilated.`;
    },
    checkRequirement: () =>
      Currency.antimatter.exponent >= 260000 && Time.thisEternity.totalMinutes.lte(1) && player.dilation.active,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Gain ${formatX(2)} Dilated Time and Time Theorems while Dilated.`;
    },
    effect: () => (player.dilation.active ? 2 : 1),
  },
  {
    id: 138,
    name: "This is what I have to do to get rid of you.",
    get description() {
      return `Reach ${formatPostBreak("1e26000")} Infinity Points without any Time Studies while Dilated.`;
    },
    checkRequirement: () =>
      player.timestudy.studies.length === 0 && player.dilation.active && Currency.infinityPoints.exponent >= 26000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Removes the downsides from Time Study 131 and 133 in the Active and Idle Time Study paths.",
  },
  {
    id: 141,
    name: "Snap back to reality",
    description: "Make a new Reality.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() {
      return `${formatX(4)} Infinity Point gain, and increase the multiplier for buying ${formatInt(10)}
      Antimatter Dimensions by +${format(0.1, 0, 1)}.`;
    },
    effects: {
      ipGain: 4,
      buyTenMult: 0.1,
    },
  },
  {
    id: 142,
    name: "How does this work?",
    description: "Unlock the automator.",
    checkRequirement: () => Player.automatorUnlocked,
    checkEvent: [
      GAME_EVENT.REALITY_RESET_AFTER,
      GAME_EVENT.REALITY_UPGRADE_BOUGHT,
      GAME_EVENT.PERK_BOUGHT,
      GAME_EVENT.BLACK_HOLE_UNLOCKED,
    ],
    get reward() {
      return `Dimension Boosts are ${formatPercents(0.5)} stronger.`;
    },
    effect: 1.5,
  },
  {
    id: 143,
    name: "Yo dawg, I heard you liked reskins...",
    get description() {
      let desc = `Have all your Eternities in your past ${formatInt(10)} Eternities be at least
      ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} times higher Eternity Points than the previous one.`;

      // This seems to confuse people so hopefully this should make it clearer
      if (AtomMilestone.am1.isReached) desc += " (Your Eternity records are unaffected by your current Eternity Points.)"
      return desc
    },
    checkRequirement: () => {
      if (player.records.recentEternities.some((i) => i[0].eq(Decimal.MAX_LIMIT))) return false;
      const eternities = player.records.recentEternities.map((run) => run[2]);
      for (let i = 0; i < eternities.length - 1; i++) {
        if (eternities[i].lt(eternities[i + 1].times(Decimal.NUMBER_MAX_VALUE))) return false;
      }
      return true;
    },
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
    reward: "Galaxies no longer reset Dimension Boosts.",
  },
  {
    id: 144,
    name: "Is this an Interstellar reference?",
    description: "Unlock the Black Hole.",
    checkRequirement: () => BlackHole(1).isUnlocked,
    checkEvent: GAME_EVENT.BLACK_HOLE_UNLOCKED,
  },
  {
    id: 145,
    name: "Are you sure these are the right way around?",
    description: "Have either Black Hole interval smaller than its duration.",
    checkRequirement: () => BlackHoles.list.some((bh) => bh.interval < bh.duration),
    checkEvent: GAME_EVENT.BLACK_HOLE_UPGRADE_BOUGHT,
    get reward() {
      return `Black Hole intervals are ${formatPercents(0.1)} shorter.`;
    },
    effect: 0.9,
  },
  {
    id: 146,
    name: "Perks of living",
    description: "Have all Perks bought.",
    checkRequirement: () => player.reality.perks.size === Perks.all.length,
    checkEvent: GAME_EVENT.PERK_BOUGHT,
    get reward() {
      return `+${formatPercents(0.01)} Glyph rarity.`;
    },
    effect: 1,
  },
  {
    id: 147,
    name: "Master of Reality",
    description: "Have all Reality upgrades bought.",
    checkRequirement: () => RealityUpgrades.allBought,
    checkEvent: GAME_EVENT.REALITY_UPGRADE_BOUGHT,
    reward: "Unlock Teresa, the Celestial of Reality.",
  },
  {
    id: 148,
    name: "Royal flush",
    description: "Reality with one of each basic Glyph type.",
    checkRequirement: () => BASIC_GLYPH_TYPES.every((type) => Glyphs.activeList.some((g) => g.type === type)),
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    reward: "Gained Glyph level is increased by number of distinct Glyph types equipped.",
    effect: () => new Set(Glyphs.activeWithoutCompanion.map((g) => g.type)).size,
    formatEffect: (value) => `+${formatInt(value)}`,
  },
  {
    id: 151,
    name: "You really didn't need it anyway",
    get description() {
      return `Get ${formatInt(800)} Antimatter Galaxies without
      having 8th Antimatter Dimensions in your current Infinity.`;
    },
    checkRequirement: () => player.galaxies >= 800 && player.requirementChecks.infinity.noAD8,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    reward: "Unlock V, the Celestial of Achievements.",
  },
  {
    id: 152,
    name: "Y'all got any more of them Glyphs?",
    get description() {
      return `Have ${formatInt(100)} Glyphs in your inventory.`;
    },
    checkRequirement: () => Glyphs.inventoryList.length >= 100,
    checkEvent: GAME_EVENT.GLYPHS_CHANGED,
  },
  {
    id: 153,
    name: 'More like "reallydoesn\'tmatter"',
    description: "Reality without producing antimatter.",
    checkRequirement: () => player.requirementChecks.reality.noAM,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
  },
  {
    id: 154,
    name: "I am speed",
    get description() {
      return `Reality in under ${formatInt(5)} seconds (game time).`;
    },
    checkRequirement: () => Time.thisReality.totalSeconds.lte(5),
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() {
      return `${formatPercents(0.1)} chance each Reality of ${formatX(2)} Realities and Perk Points.`;
    },
    effect: 0.1,
  },
  {
    id: 155,
    name: "Achievement #15983",
    get description() {
      return `Play for ${formatFloat(13.7, 1)} billion years${atomTimeText()}.`;
    },
    checkRequirement: () => Time.thisCollapse.totalYears.gt(13.7e9),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Black Hole durations are ${formatPercents(0.1)} longer.`;
    },
    effect: 1.1,
  },
  {
    id: 156,
    name: "College Dropout",
    description: "Reality without buying Time Theorems.",
    checkRequirement: () => player.requirementChecks.reality.noPurchasedTT,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() {
      return `Gain ${formatX(2.5, 0, 1)} generated Time Theorems, and a free coupon to McDonalds™️.`;
    },
    effect: 2.5,
  },
  {
    id: 157,
    name: "It's super effective!",
    get description() {
      return `Get a Glyph with ${formatInt(4)} effects.`;
    },
    checkRequirement: () =>
      Glyphs.activeList
        .concat(Glyphs.inventoryList)
        .map((glyph) => getGlyphEffectsFromBitmask(glyph.effects, 0, 0).filter((effect) => effect.isGenerated).length)
        .max() >= 4,
    checkEvent: GAME_EVENT.GLYPHS_CHANGED,
  },
  {
    id: 158,
    name: "Bruh, are you like, inside the hole?",
    description: "Make both Black Holes permanent.",
    checkRequirement: () => BlackHole(1).isPermanent && BlackHole(2).isPermanent,
    checkEvent: GAME_EVENT.BLACK_HOLE_UPGRADE_BOUGHT,
    get reward() {
      return `Black Hole power increased by ${formatPercents(0.1)}.`;
    },
    effect: 1.1,
  },
  {
    id: 161,
    name: "that's where you're wrong kiddo",
    get description() {
      return `Get ${formatPostBreak(DC.E1E8)} antimatter while Dilated.`;
    },
    checkRequirement: () => Currency.antimatter.exponent >= 100000000 && player.dilation.active,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 162,
    name: "Reinstalled the game and rejoined the server",
    description: "Have every Time Study at once.",
    checkRequirement: () => player.timestudy.studies.length >= 58,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 163,
    name: "Actually, super easy! Barely an inconvenience!",
    get description() {
      return `Complete all the Eternity Challenges ${formatInt(5)} times with less than ${formatInt(1)}
      second (game time) in your current Reality.`;
    },
    checkRequirement: () =>
      EternityChallenges.all.map((ec) => ec.completions).min() >= 5 && Time.thisReality.totalSeconds.lte(1),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 164,
    name: "Infinity times two",
    get description() {
      return `Get ${format(Decimal.NUMBER_MAX_VALUE, 1)} Infinities.`;
    },
    checkRequirement: () => Currency.infinitiesTotal.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Gain ×${formatInt(1024)} more Infinities.`;
    },
    effect: 1024,
  },
  {
    id: 165,
    name: "Perfectly balanced",
    get description() {
      return `Get a level ${formatInt(5000)} Glyph with all Glyph level factors equally weighted.`;
    },
    checkRequirement: () =>
      gainedGlyphLevel().actualLevel >= 5000 &&
      ["repl", "dt", "eternities"].every(
        (i) => player.celestials.effarig.glyphWeights[i] === player.celestials.effarig.glyphWeights.ep,
      ),
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    reward: "Unlock optimal automatic Glyph level factor adjustment.",
  },
  {
    id: 166,
    name: "Nicenice.",
    get description() {
      return `Get a Glyph with level exactly ${formatInt(6969)}.`;
    },
    checkRequirement: () => gainedGlyphLevel().actualLevel === 6969,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() {
      return `+${formatInt(69)} to Glyph level.`;
    },
    effect: 69,
  },
  {
    id: 167,
    name: "Mr. Layer? Sorry, you're not on the list",
    get description() {
      return `Reach ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} Reality Machines.`;
    },
    checkRequirement: () => Currency.realityMachines.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Gain more Reality Machines based on your current Reality Machines.",
    effect: () => Math.clampMin(1, Currency.realityMachines.value.log2()),
    formatEffect: (value) => `${formatX(value, 2, 2)}`,
  },
  {
    id: 168,
    name: "Woah, we're halfway there",
    get description() {
      return `Get ${formatInt(50)} total Ra Celestial Memory levels.`;
    },
    checkRequirement: () => Ra.totalPetLevel >= 50,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Get ${formatPercents(0.1)} more memories.`;
    },
    effect: 1.1,
  },
  {
    id: 171,
    name: "The god is delighted",
    description: "Sacrifice every sacrificable Glyph type at least once.",
    checkRequirement: () => Object.values(player.reality.glyphs.sac).every((s) => s.gt(0)),
    checkEvent: GAME_EVENT.GLYPHS_CHANGED,
    get reward() {
      return `Glyph sacrifice is ${formatX(2)} stronger.`;
    },
    effect: 2,
  },
  {
    id: 172,
    name: "Hitchhiker's Guide to Reality",
    get description() {
      return `Reality for ${format(Decimal.NUMBER_MAX_VALUE, 1)} Reality Machines without having
      any Charged Infinity Upgrades, having any equipped Glyphs, or buying any Triad Studies.`;
    },
    checkRequirement: () =>
      MachineHandler.gainedRealityMachines.gte(Decimal.NUMBER_MAX_VALUE) &&
      player.celestials.ra.charged.size === 0 &&
      Glyphs.activeWithoutCompanion.length === 0 &&
      player.requirementChecks.reality.noTriads,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
  },
  {
    id: 173,
    name: "Cet accomplissement n'existe pas III",
    get description() {
      return `Reach ${formatPostBreak(DC.D9_99999E999, 5, 0)} Reality Machines.`;
    },
    checkRequirement: () => player.reality.realityMachines.gte(DC.D9_99999E999),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 174,
    name: "Don't you already have two of these?",
    description: "Get a Singularity.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.SINGULARITY_RESET_BEFORE,
  },
  {
    id: 175,
    name: "The First Antihistorian",
    get description() {
      return `Get ${formatInt(Ra.alchemyResourceCap)} of all Alchemy Resources.`;
    },
    checkRequirement: () => AlchemyResources.all.every((x) => x.amount >= Ra.alchemyResourceCap),
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
    get reward() {
      return `Synergism can go above ${formatPercents(1)} and Momentum increases ${formatX(10)} faster.`;
    },
    effect: 10,
  },
  {
    id: 176,
    name: "Mom counted to 3",
    description: "Annihilate your Dark Matter Dimensions.",
  },
  {
    id: 177,
    name: "This mile took a celestial",
    description: "Complete all Singularity Milestones at least once.",
    checkRequirement: () => SingularityMilestones.all.every((x) => x.completions > 0),
    checkEvent: GAME_EVENT.SINGULARITY_RESET_AFTER,
  },
  {
    id: 178,
    name: "Destroyer of Worlds",
    get description() {
      return `Get ${formatInt(100000)} Antimatter Galaxies.`;
    },
    checkRequirement: () => player.galaxies >= 100000,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    get reward() {
      return `All Galaxies are ${formatPercents(0.01)} stronger.`;
    },
    effect: 1.01,
  },
  {
    id: 181,
    displayId: 666,
    name: "Antimatter Dimensions Eternal",
    description: "Doom your Reality.",
    checkRequirement: () => Pelle.isDoomed,
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
  },
  {
    id: 182,
    name: "One more time",
    description: "Permanently gain back all Antimatter Dimension autobuyers.",
    checkRequirement: () =>
      Pelle.isDoomed &&
      PelleUpgrade.antimatterDimAutobuyers1.canBeApplied &&
      PelleUpgrade.antimatterDimAutobuyers2.canBeApplied,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 183,
    name: "Déjà vOoM",
    description: "Complete Infinity Challenge 5 while Doomed.",
    checkRequirement: () => Pelle.isDoomed && InfinityChallenge(5).isCompleted,
    // Because we give the Infinity Challenge completion
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    // Weirdly specific reward? Yes, its V's ST bonus because we forgot to disable it
    // when balancing Pelle and only realised too late.
    get reward() {
      return `All Antimatter Dimensions are raised to ${formatPow(1.0812403840463596, 0, 3)}`;
    },
    effect: 1.0812403840463596,
  },
  {
    id: 184,
    name: "You're out!",
    description: "Encounter the third Pelle Strike.",
    checkRequirement: () => PelleStrikes.eternity.hasStrike,
    checkEvent: GAME_EVENT.PELLE_STRIKE_UNLOCKED,
  },
  {
    id: 185,
    name: "Four score and seven years ago",
    description: "Encounter the fourth Pelle Strike.",
    checkRequirement: () => PelleStrikes.ECs.hasStrike,
    checkEvent: GAME_EVENT.PELLE_STRIKE_UNLOCKED,
  },
  {
    id: 186,
    displayId: 181,
    name: "An unhealthy obsession",
    description: `Purchase Time Study 181 while Doomed.`,
  },
  {
    id: 187,
    name: "The One with Dilated Time",
    description: "Unlock Dilation while Doomed.",
    checkRequirement: () => PelleStrikes.dilation.hasStrike,
    checkEvent: GAME_EVENT.PELLE_STRIKE_UNLOCKED,
    // We forgot to disable a singularity milestone while balancing Pelle; now it's disabled
    // and this upgrade has the same effect as it used to.
    get reward() {
      return `Increase the multiplier per repeatable Dilated Time
      multiplier upgrade by ${formatX(1.35, 0, 2)}.`;
    },
    effect: 1.35,
  },
  {
    id: 188,
    name: "The End",
    get description() {
      if (PlayerProgress.atomUnlocked()) return `Reach ${format(Decimal.MAX_VALUE)} Antimatter.`;
      return "Beat the game.";
    },
    checkRequirement: () => GameEnd.beaten,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 191,
    name: "Back to Basics",
    description: "Collapse once.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.COLLAPSE_RESET_BEFORE,
    get reward() {
      return `${formatX(2, 0)} to Atom gain for every Atom Milestone completed, except the first.`;
    },
    effect: () => Math.pow(2, Math.max(AtomMilestone.all.countWhere((i) => i.isReached) - 1, 0)),
    formatEffect: (x) => formatX(x, 0, 2),
  },
  {
    id: 192,
    name: "Milestone Master",
    description: "Obtain the first five Atom Milestones.",
    checkRequirement: () => AtomMilestone.all.slice(0, 5).every((i) => i.isReached),
    checkEvent: GAME_EVENT.COLLAPSE_RESET_BEFORE,
  },
  {
    id: 193,
    name: "Speedrun Master",
    description: "Obtain the last five Atom Milestones.",
    checkRequirement: () => AtomMilestone.all.slice(5).every((i) => i.isReached),
    checkEvent: GAME_EVENT.COLLAPSE_RESET_BEFORE,
  },
  {
    id: 194,
    name: "Antimatter Chaos",
    description: "Break the Universe.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.BREAK_UNIVERSE,
  },
  {
    id: 195,
    name: "The Subatomic Universe",
    description: "Have at least one of each type of Atomic Particle.",
    checkRequirement: () => player.atom.particles.slice(0, 3).every((i) => i.gte(1)),
    checkEvent: GAME_EVENT.ATOMIC_PARTICLE_CONVERSION,
  },
  {
    id: 196,
    name: "???",
    description: "Placeholder.",
    checkRequirement: () => false,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 197,
    name: "???",
    description: "Placeholder.",
    checkRequirement: () => false,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 198,
    name: "???",
    description: "Placeholder.",
    checkRequirement: () => false,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
];
